import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DISPLAY_LANG } from "../../../config";
import axios from '../../../axios';
import { getData } from "country-list";
import "../../../stylesheets/sslOrder.css";

const contactTexts = {
    en: "Technical Contact is the same as Admin Contact",
    ru: "Технический контакт совпадает с административным",
    am: "Տեխնիկական կոնտակտի տվյալները նույնն են, ինչ Ադմինիստրատորի տվյալները",
};

function CountrySelect({ value, onChange, disabled }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const containerRef = useRef(null);

  const countries = getData()
    .map((c) => ({
      code: c.code,
      name: c.name.replace(/\s*\([^)]*\)/g, "").trim(),
      flagUrl: `https://flagcdn.com/w40/${c.code.toLowerCase()}.png`,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedCountry = countries.find((c) => c.code === value);

  const filteredCountries = countries.filter(
    (c) =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.code.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className={`country-select-container ${disabled ? "disabled" : ""}`} ref={containerRef}>
      <div
        className={`country-select-trigger ${isOpen ? "open" : ""} ${disabled ? "disabled" : ""}`}
        onClick={() => {
          if (!disabled) setIsOpen(!isOpen);
        }}
      >
        {selectedCountry ? (
          <span className="selected-value">
            <img
              src={selectedCountry.flagUrl}
              alt={selectedCountry.name}
              className="flag-img"
            />
            <span className="name">{selectedCountry.name}</span>
          </span>
        ) : (
          <span className="placeholder">Select Country</span>
        )}
        <span className="arrow">{isOpen ? "▲" : "▼"}</span>
      </div>

      <input
        type="text"
        tabIndex={-1}
        value={value}
        onChange={() => {}}
        required
        disabled={disabled}
        style={{
          opacity: 0,
          width: 0,
          height: 0,
          position: "absolute",
          pointerEvents: "none",
        }}
      />

      {isOpen && !disabled && (
        <div className="country-select-dropdown">
          <input
            type="text"
            className="country-search-input"
            placeholder="Search country..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
          <ul className="country-options-list">
            {filteredCountries.map((c) => (
              <li
                key={c.code}
                className={`country-option ${value === c.code ? "selected" : ""}`}
                onClick={() => {
                  onChange(c.code);
                  setIsOpen(false);
                  setSearch("");
                }}
              >
                <img
                  src={c.flagUrl}
                  alt={c.name}
                  className="flag-img"
                />
                <span className="name">{c.name}</span>
              </li>
            ))}
            {filteredCountries.length === 0 && (
              <li className="no-options">No countries found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}


export default function SSLOrder() {
    const [productCode, setProductCode] = useState("");
    const [csr, setCsr] = useState("");
    const [approverEmail, setApproverEmail] = useState("");
    const [approvedDomainName, setApprovedDomainName] = useState("");
    const [validityPeriod, setValidityPeriod] = useState(12);
    const [serverCount, setServerCount] = useState(1);
    const [sslSelectedServerType, setSslSelectedServerType] = useState("");
    const [cursorLoad, setCursorLoad] = useState(false);
    const [sameContact, setSameContact] = useState(false);
    const navigate = useNavigate();

    const [adminContact, setAdminContact] = useState({
        FirstName: "",
        LastName: "",
        Phone: "",
        Email: "",
        Title: "",
        OrganizationName: "",
        AddressLine1: "",
        City: "",
        Region: "",
        PostalCode: "",
        Country: "",
    });

    const [technicalContact, setTechnicalContact] = useState({
        FirstName: "",
        LastName: "",
        Phone: "",
        Email: "",
        Title: "",
        OrganizationName: "",
        AddressLine1: "",
        City: "",
        Region: "",
        PostalCode: "",
        Country: "",
    });

    // Sectigo/Comodo Web Server Types
    const sectigoWebServerTypes = [
        { name: "Apache", code: "apache" },
        { name: "WHM/cPanel", code: "cpanel" },
        { name: "Java-based servers", code: "javawebserver" },
        { name: "Microsoft IIS 5.x to 6.x", code: "iis5" },
        { name: "Microsoft IIS 7.x and later", code: "iis" },
        { name: "Nginx", code: "nginx" },
        { name: "Oracle", code: "oracle" },
        { name: "Plesk", code: "plesk" },
        { name: "Other", code: "other" }
    ];

    useEffect(() => {
        const sslApprovedDomainEmail = localStorage.getItem("ssl_approved_domain_email");
        const sslApprovedDomainName = localStorage.getItem("ssl_approved_domain_name");
        const sslCsr = localStorage.getItem("ssl_csr");
        const sslProductCode = localStorage.getItem("ssl_product_code");

        if (sslApprovedDomainEmail) setApproverEmail(sslApprovedDomainEmail);
        if (sslApprovedDomainName) setApprovedDomainName(sslApprovedDomainName);
        if (sslCsr) setCsr(sslCsr);
        if (sslProductCode) setProductCode(sslProductCode);
    }, []);

    useEffect(() => {
        if (sameContact) {
            setTechnicalContact(adminContact);
        }
    }, [adminContact, sameContact]);

    useEffect(() => {
        console.log("adminContact.Country changed:", adminContact.Country);
    }, [adminContact.Country]);

    useEffect(() => {
        console.log("technicalContact.Country changed:", technicalContact.Country);
    }, [technicalContact.Country]);

    const handleChangeAdminContact = (field, value) => {
        setAdminContact((prev) => ({ ...prev, [field]: value }));
    };

    const handleChangeTechnicalContact = (field, value) => {
        setTechnicalContact((prev) => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setCursorLoad(true);

        const payload = {
            custom_order_id: `SSL-${Date.now()}`,
            product_code: productCode,
            domain_name: approvedDomainName,
            csr: csr,
            approver_email: approverEmail,
            validity_period: validityPeriod,
            server_count: serverCount,
            apacheopenssl: sslSelectedServerType,

            admin_contact: {
                FirstName: adminContact.FirstName,
                LastName: adminContact.LastName,
                Phone: adminContact.Phone,
                Email: adminContact.Email,
                Title: adminContact.Title,
                OrganizationName: adminContact.OrganizationName,
                AddressLine1: adminContact.AddressLine1,
                City: adminContact.City,
                Region: adminContact.Region,
                PostalCode: adminContact.PostalCode,
                Country: adminContact.Country,
            },

            technical_contact: {
                FirstName: technicalContact.FirstName,
                LastName: technicalContact.LastName,
                Phone: technicalContact.Phone,
                Email: technicalContact.Email,
                Title: technicalContact.Title,
                OrganizationName: technicalContact.OrganizationName,
                AddressLine1: technicalContact.AddressLine1,
                City: technicalContact.City,
                Region: technicalContact.Region,
                PostalCode: technicalContact.PostalCode,
                Country: technicalContact.Country,
            },
        };

        try {
            const res = await axios.post("ssl/new-order", payload);
            localStorage.setItem('SSL_ORDER_TheSSLStoreOrderID', res.data.TheSSLStoreOrderID);
            localStorage.setItem('SSL_ORDER_CustomOrderID', res.data.CustomOrderID);
            navigate('/user/ssl/order-status')
        } catch (err) {
            console.error("ORDER ERROR:", err);
            alert("Error submitting SSL order. Please check the console for details.");
        } finally {
            setCursorLoad(false);
        }
    };

    return (
        <div className="ssl-order-page">
            <h1>SSL Order</h1>

            <form className="ssl-form" onSubmit={handleSubmit}>
                <div className="same-contact">
                    <label>
                        <input
                            type="checkbox"
                            checked={sameContact}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                setSameContact(checked);

                                if (checked) {
                                    setTechnicalContact(adminContact);
                                } else {
                                    setTechnicalContact({
                                        FirstName: "",
                                        LastName: "",
                                        Phone: "",
                                        Email: "",
                                        Title: "",
                                        OrganizationName: "",
                                        AddressLine1: "",
                                        City: "",
                                        Region: "",
                                        PostalCode: "",
                                        Country: "",
                                    });
                                }
                            }}
                        />

                        {contactTexts[DISPLAY_LANG]}
                    </label>
                </div>

                <section className="section">
                    <h2>Admin Contact</h2>
                    <div className="grid">
                        <label>
                            First name
                            <input value={adminContact.FirstName} onChange={(e) => handleChangeAdminContact("FirstName", e.target.value)} required />
                        </label>
                        <label>
                            Last name
                            <input value={adminContact.LastName} onChange={(e) => handleChangeAdminContact("LastName", e.target.value)} required />
                        </label>
                        <label>
                            Email
                            <input type="email" value={adminContact.Email} onChange={(e) => handleChangeAdminContact("Email", e.target.value)} required />
                        </label>
                        <label>
                            Phone
                            <input value={adminContact.Phone} onChange={(e) => handleChangeAdminContact("Phone", e.target.value)} required />
                        </label>
                        <label>
                            Title
                            <input value={adminContact.Title} onChange={(e) => handleChangeAdminContact("Title", e.target.value)} required />
                        </label>
                        <label>
                            Organization name
                            <input
                                value={adminContact.OrganizationName}
                                onChange={(e) =>
                                    handleChangeAdminContact("OrganizationName", e.target.value)
                                }
                                required
                            />
                        </label>
                        <label>
                            Address line 1
                            <input
                                value={adminContact.AddressLine1}
                                onChange={(e) =>
                                    handleChangeAdminContact("AddressLine1", e.target.value)
                                }
                                required
                            />
                        </label>
                        <label>
                            City
                            <input
                                value={adminContact.City}
                                onChange={(e) =>
                                    handleChangeAdminContact("City", e.target.value)
                                }
                                required
                            />
                        </label>
                        <label>
                            Region
                            <input
                                value={adminContact.Region}
                                onChange={(e) =>
                                    handleChangeAdminContact("Region", e.target.value)
                                }
                                required
                            />
                        </label>
                        <label>
                            Postal Code
                            <input
                                value={adminContact.PostalCode}
                                onChange={(e) =>
                                    handleChangeAdminContact("PostalCode", e.target.value)
                                }
                                required
                            />
                        </label>
                        <label>
                            Country
                            <CountrySelect
                                value={adminContact.Country}
                                onChange={(code) => handleChangeAdminContact("Country", code)}
                            />
                        </label>
                    </div>
                </section>

                <section className="section">
                    <h2>Technical Contact</h2>
                    <div className="grid">
                        <label>
                            First name
                            <input value={technicalContact.FirstName} disabled={sameContact} onChange={(e) => handleChangeTechnicalContact("FirstName", e.target.value)} required />
                        </label>
                        <label>
                            Last name
                            <input value={technicalContact.LastName} disabled={sameContact} onChange={(e) => handleChangeTechnicalContact("LastName", e.target.value)} required />
                        </label>
                        <label>
                            Email
                            <input type="email" value={technicalContact.Email} disabled={sameContact} onChange={(e) => handleChangeTechnicalContact("Email", e.target.value)} required />
                        </label>
                        <label>
                            Phone
                            <input value={technicalContact.Phone} disabled={sameContact} onChange={(e) => handleChangeTechnicalContact("Phone", e.target.value)} required />
                        </label>
                        <label>
                            Title
                            <input value={technicalContact.Title} disabled={sameContact} onChange={(e) => handleChangeTechnicalContact("Title", e.target.value)} required />
                        </label>
                        <label>
                            Organization name
                            <input
                                value={technicalContact.OrganizationName}
                                disabled={sameContact}
                                onChange={(e) =>
                                    handleChangeTechnicalContact("OrganizationName", e.target.value)
                                }
                                required
                            />
                        </label>
                        <label>
                            Address line 1
                            <input
                                value={technicalContact.AddressLine1}
                                disabled={sameContact}
                                onChange={(e) =>
                                    handleChangeTechnicalContact("AddressLine1", e.target.value)
                                }
                                required
                            />
                        </label>
                        <label>
                            City
                            <input
                                value={technicalContact.City}
                                disabled={sameContact}
                                onChange={(e) =>
                                    handleChangeTechnicalContact("City", e.target.value)
                                }
                                required
                            />
                        </label>
                        <label>
                            Region
                            <input
                                value={technicalContact.Region}
                                disabled={sameContact}
                                onChange={(e) =>
                                    handleChangeTechnicalContact("Region", e.target.value)
                                }
                                required
                            />
                        </label>
                        <label>
                            Postal Code
                            <input
                                value={technicalContact.PostalCode}
                                disabled={sameContact}
                                onChange={(e) =>
                                    handleChangeTechnicalContact("PostalCode", e.target.value)
                                }
                                required
                            />
                        </label>
                        <label>
                            Country
                            <CountrySelect
                                value={technicalContact.Country}
                                disabled={sameContact}
                                onChange={(code) => handleChangeTechnicalContact("Country", code)}
                            />
                        </label>
                    </div>
                </section>

                <section className="section">
                    <h2>Server Type</h2>

                    <label className="server-type-select">
                        Select your web server

                        <select
                            value={sslSelectedServerType}
                            onChange={(e) => setSslSelectedServerType(e.target.value)}
                            required
                        >
                            <option value="" disabled>Choose server type</option>

                            {sectigoWebServerTypes.map((server) => (
                                <option
                                    key={server.code}
                                    value={server.code}
                                >
                                    {server.name}
                                </option>
                            ))}
                        </select>
                    </label>
                </section>

                <div className="actions">
                    <button type="submit" className="primary" disabled={cursorLoad} style={{ cursor: cursorLoad ? 'wait' : 'pointer' }}>
                        {cursorLoad ? 'Submitting...' : 'Submit Order'}
                    </button>
                </div>
            </form>
        </div>
    );
}
